

export default {
  data() {
    return {
      ready: false,
    }
  },
  head() {
    return this.$utils.head(this.story)
  },
  mounted() {
    setTimeout(() => this.ready = true, 3000)
  },
}
